import { useEffect, useState } from 'react';

/**
 * Delays a value. Used for the search box and the price-range slider, where
 * firing a request per keystroke would send twenty requests to answer one
 * question.
 */
export const useDebounced = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};

export default useDebounced;
